import { useModalsAndWindow } from '../context/ModalsAndWindowContext';
import { reportAppUrlEnd, reportAppUrlStart } from '../bi/bi';
export const useOauthBroadcastRedirectHandler = () => {
  const {
    newWindowHandlers: {
      showLoader: showLoaderInWindow,
      broadcastChannel,
      updateWindowSrcWithUrl
    }
  } = useModalsAndWindow();
  return (resolve, appUri) => {
    const handleFirstRedirect = event => {
      const redirectUrl = event.data.redirectUrl;
      if (event.data.type === 'receivedRedirectUrl' && redirectUrl) {
        const state = event.data.state === 'undefined' ? undefined : event.data.state;
        showLoaderInWindow();
        reportAppUrlEnd({
          url: appUri
        });
        resolve({
          redirectUrlAnswerFromTpa: redirectUrl,
          oauth2State: state
        });
      } else {
        resolve({});
      }
    };
    broadcastChannel.onmessage = handleFirstRedirect;
    updateWindowSrcWithUrl(appUri);
    reportAppUrlStart({
      url: appUri
    });
  };
};
//# sourceMappingURL=useOauthBroadcastRedirectHandler.js.map